<template>
  <aside class="main-sidebar">
    <section class="sidebar">
      <ul class="sidebar-menu">
        <li class="header">MAIN NAVIGATION</li>
        <template v-for="link in datarole">
          <template v-if="link.to">
            <li>
              <router-link :to="link.to">
                <i :class="[link.class]"></i> <span>{{ link.title }}</span>
              </router-link>
            </li>
          </template>
          <template v-if="!link.to">
            <li>
              <a style="cursor: pointer;" @click="toggle">
                <i :class="[link.class]"></i> <span>{{ link.title }}</span>
              </a>
              <template v-if="link.children">
                <ul class="sidebar-menu" style="display: none;">
                  <template v-for="link in link.children">
                    <li v-if="link.title === 'Role Setup' || link.title === 'Merchant User Setup'">
                      <a :href="link.to" target="_blank" style="padding-left: 40px;">
                        <i :class="[link.class]"></i> <span>{{ link.title }}</span>
                      </a>
                    </li>
                    <li v-else>
                      <router-link :to="link.to" style="padding-left: 40px;">
                        <i :class="[link.class]"></i> <span>{{ link.title }}</span>
                      </router-link>
                    </li>
                  </template>
                </ul>
              </template>
            </li>
          </template>
        </template>
      </ul>
    </section>
  </aside>
</template>

<script>
  import { EXTRANET_WEB_URL, EXTRANET_APP_ID, EXTRANET_APP_SECRET } from '../../config';

  export default {
    name: 'DashboardSidebar',

    data() {
      return {
        datarole: [],
        privilege: null,
        token: null,
      };
    },

    methods: {
      toggle(e) {
        const parent = $(e.currentTarget).closest('li');
        const children = parent.find('ul.sidebar-menu');

        if (children.css('display') === 'none') {
          children.css('display', 'block');
        } else {
          children.css('display', 'none');
        }
      },

      generateMenuData(privilege) {
        const menu = [];
        if (privilege.includes('dashboard')) {
          menu.push({
            to: '/dashboard',
            class: 'fa fa-dashboard',
            title: 'Dashboard',
          });
        }

        if (privilege.includes('highlights')) {
          menu.push({
            to: { name: 'highlights-edit' },
            class: 'fa fa-star',
            title: 'Highlights',
          });
        }

        if (privilege.includes('badges')) {
          menu.push({
            to: { name: 'badges-index' },
            class: 'fa fa-certificate',
            title: 'Badges',
          });
        }

        if (privilege.includes('categories')) {
          menu.push({
            to: { name: 'category-index' },
            class: 'fa fa-th-list',
            title: 'Categories',
          });
        }

        if (privilege.includes('destinations')) {
          menu.push({
            to: { name: 'destination-index', query: { type: 'domestic' } },
            class: 'fa fa-compass',
            title: 'Destinations',
          });
        }

        if (privilege.includes('destinations')) {
          menu.push({
            to: { name: 'review-index' },
            class: 'fa fa-star',
            title: 'Explore Review',
          });
        }

        if (privilege.includes('tags')) {
          menu.push({
            to: { name: 'tag-index' },
            class: 'fa fa-tags',
            title: 'Tags',
          });
        }

        if (privilege.includes('sources')) {
          menu.push({
            to: { name: 'source-index' },
            class: 'fa fa-vcard',
            title: 'Sources',
          });
        }

        if (privilege.includes('merchants')) {
          menu.push({
            to: { name: 'merchant-index' },
            class: 'fa fa-vcard',
            title: 'Merchants',
          });
        }

        if (privilege.includes('inventory-ticket')) {
          menu.push({
            to: { name: 'inventory-index' },
            class: 'fa fa-tags',
            title: 'Inventory Ticket',
          });
        }

        if (privilege.includes('products')) {
          menu.push({
            to: { name: 'product-index' },
            class: 'fa fa-plane',
            title: 'Products',
          });
        }

        if (privilege.includes('klook')) {
          menu.push({
            to: { name: 'klook-index' },
            class: 'fa fa-ticket',
            title: 'Klook',
          });
        }

        if (privilege.includes('promotions')) {
          const submenu = [];

          if (privilege.includes('payments')) {
            submenu.push({
              to: '/promo/config',
              class: 'fa fa-credit-card',
              title: 'Payments',
            });
          }

          if (privilege.includes('code')) {
            submenu.push({
              to: '/promo/code',
              class: 'fa fa-ticket',
              title: 'Code',
            });
          }

          if (privilege.includes('bin')) {
            submenu.push({
              to: '/promo/bin',
              class: 'fa fa-bank',
              title: 'BIN',
            });
          }

          menu.push({
            class: 'fa fa-gift',
            title: 'Promotions',
            children: submenu,
          });
        }

        if (privilege.includes('orders')) {
          const submenu = [];

          if (privilege.includes('order-summary')) {
            submenu.push({
              to: '/orders',
              class: 'fa fa-file-text-o',
              title: 'Orders Summary',
            });
          }

          if (privilege.includes('payment-to-merchant')) {
            submenu.push({
              to: '/order-payment',
              class: 'fa fa-money',
              title: 'Payment to Merchant',
            });
          }

          menu.push({
            class: 'fa fa-shopping-cart',
            title: 'Orders',
            children: submenu,
          });
        }

        if (privilege.includes('ticketing')) {
          const submenu = [];

          if (privilege.includes('ticketing-redeem')) {
            submenu.push({
              to: '/ticketing/redeem',
              class: 'fa fa-star',
              title: 'Redeem',
            });
          }

          if (privilege.includes('ticketing-check-in')) {
            submenu.push({
              to: '/ticketing/check-in',
              class: 'fa fa-tags',
              title: 'Check In',
            });
          }

          menu.push({
            class: 'fa fa-database',
            title: 'Ticketing',
            children: submenu,
          });
        }

        if (privilege.includes('user-setup')) {
          const submenu = [];

          if (privilege.includes('role-setup')) {
            submenu.push({
              to: `${EXTRANET_WEB_URL}/user-setup/role/?appId=${EXTRANET_APP_ID}&appSecret=${EXTRANET_APP_SECRET}&token=${this.token}`,
              class: 'fa fa-key',
              title: 'Role Setup',
            });
          }

          if (privilege.includes('internal-user-setup')) {
            submenu.push({
              to: '/user-setup',
              class: 'fa fa-user-circle',
              title: 'Internal User Setup',
            });
          }

          if (privilege.includes('merchant-user-setup')) {
            submenu.push({
              to: `${EXTRANET_WEB_URL}/user-setup/merchant-user/?appId=${EXTRANET_APP_ID}&appSecret=${EXTRANET_APP_SECRET}&token=${this.token}`,
              class: 'fa fa-user-o',
              title: 'Merchant User Setup',
            });
          }

          menu.push({
            class: 'fa fa-cogs',
            title: 'User Management',
            children: submenu,
          });
        }

        return menu;
      },
    },

    created() {
      this.privilege = this.$store.state.user.role;
      this.token = this.$store.state.token;
      this.datarole = this.generateMenuData(this.$store.state.user.privilege);
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/partials/Sidebar.vue